import { Link } from 'react-router-dom';
import { Button } from '@design-system/Button';
import * as P from '@/constants/paths';
import { Player } from '@lottiefiles/react-lottie-player';
import SuccessGreenLottie from '@/assets/success-green.json';

export const QuestionnaireCompleted = () => {
  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen p-4"
      data-testid="questionnaireCompleted-container"
    >
      <Player
        autoplay
        src={SuccessGreenLottie}
        keepLastFrame
        className="w-36 h-36 object-cover"
        data-testid="questionnaireCompleted-animation"
      />
      <h2
        className="typography-h1 text-center mb-4"
        data-testid="questionnaireCompleted-title"
      >
        Questionnaire Completed
      </h2>
      <div
        className="flex justify-center mb-12"
        data-testid="questionnaireCompleted-description"
      >
        <p className="typography-body text-center text-secondary max-w-sm">
          You can make changes to your responses anytime before your results and
          recommendations are released.
        </p>
      </div>
      <Link to={P.HOME_PATH} data-testid="questionnaireCompleted-actionLink">
        <Button
          type="button"
          className="w-full py-3 text-white font-semibold bg-black rounded-lg"
          data-testid="questionnaireCompleted-actionButton"
        >
          Return Home
        </Button>
      </Link>
    </div>
  );
};
